import { render, staticRenderFns } from "./TableNewDailyControls.vue?vue&type=template&id=71771dcd"
import script from "./TableNewDailyControls.vue?vue&type=script&lang=ts"
export * from "./TableNewDailyControls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports